import { styled } from '@mui/material/styles';
import { FormHelperText, Radio, RadioGroup } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const StyledRadio = styled(Radio)`
  &.Mui-checked {
    color: ${customPalette.blue.main};
  }

  &:hover {
    background-color: ${customPalette.blue.main}10;
  }

  &.Mui-disabled {
    color: ${customPalette.grey[300]};
  }
`;

export const StyledErrorText = styled(FormHelperText)`
  margin-left: 0;
  margin-right: 0;
  color: ${customPalette.negative[600]};
`;

export const HorizontalRadioGroup = styled(RadioGroup)`
  flex-direction: row;
  justify-content: space-between;
  width: 300px; // możesz dostosować szerokość
  margin: 20px 0;
`;
